import { themeQuartz } from 'ag-grid-community';

export const themeSource = themeQuartz.withParams({
  fontSize: '13px',
  cellHorizontalPaddingScale: 0.8,
  headerVerticalPaddingScale: 0.6,
});
